import { Check } from 'lucide-react'
import type { AnswerInputProps } from '../QuestionRenderer'

export function NPSInput({ question, value, onChange, onSubmit }: AnswerInputProps<number>) {
  const scores = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10]

  function color(score: number) {
    if (score <= 6) return 'bg-rose-500'
    if (score <= 8) return 'bg-amber-400'
    return 'bg-emerald-500'
  }

  return (
    <div>
      <div
        className="grid grid-cols-6 sm:grid-cols-11"
        style={{ gap: 'var(--form-answer-gap,0.875rem)' }}
      >
        {scores.map((score) => (
          <button
            key={score}
            type="button"
            onClick={() => {
              onChange(score)
              window.setTimeout(onSubmit, 120)
            }}
            className={`relative grid min-h-12 place-items-center rounded-md border text-sm font-semibold transition-transform ${
              value === score
                ? `${color(score)} scale-105 border-transparent text-white`
                : 'border-slate-200'
            }`}
            style={
              value === score
                ? {
                    borderRadius: 'var(--form-radius,8px)',
                    fontFamily: 'var(--form-body-font,var(--form-font,Geist))',
                    fontSize: 'var(--form-meta-size,0.9375rem)',
                  }
                : {
                    background: 'color-mix(in srgb, var(--form-bg,#F8FAFC) 86%, white)',
                    borderColor: 'color-mix(in srgb, var(--form-accent,#6366F1) 24%, transparent)',
                    borderRadius: 'var(--form-radius,8px)',
                    color: 'var(--form-answer,#334155)',
                    fontFamily: 'var(--form-body-font,var(--form-font,Geist))',
                    fontSize: 'var(--form-meta-size,0.9375rem)',
                  }
            }
          >
            {score}
            {value === score && <Check className="absolute right-1 top-1 size-3" />}
          </button>
        ))}
      </div>
      <div
        className="mt-3 flex justify-between gap-4 text-sm"
        style={{
          color: 'var(--form-answer,#64748B)',
          fontFamily: 'var(--form-body-font,var(--form-font,Geist))',
          fontSize: 'var(--form-meta-size,0.9375rem)',
        }}
      >
        <span>{question.settings.startLabel ?? '完全不推薦'}</span>
        <span>{question.settings.endLabel ?? '極力推薦'}</span>
      </div>
    </div>
  )
}
